import { Outlet, createBrowserRouter } from "react-router-dom";
import SignIn from "../components/login/SignIn";
import SignUp from "../components/login/SignUp";
import LoginHome from "../components/login/LoginHome";
import DefaultLayout from "./DefaultLayout";
import React from "react";
import Posts from "../components/Posts";
import Container from '@mui/material/Container';
import AddArticle from "../components/admin/AddArticle";
import ArticleList from "../components/admin/ArticleList";
import EditArticle from "../components/admin/EditArticle";
import ManageImages from "../components/admin/ManageImages";
import ArticleDetails from "../components/ArticleDetails";
import Header from "../components/Header";
import CategoryArticles from '../components/CategoryArticles';

export const router = createBrowserRouter([
    {
        path: "/admin",
        element: (
            <DefaultLayout>
                <Outlet />
            </DefaultLayout>
        ),
        children: [
            {
                path: "",
                element: <LoginHome />,
            },
            {
                path: "addarticle",
                element: <AddArticle />,
            },
            {
                path: "articlelist",
                element: <ArticleList />,
            },
            {
                path: "editarticle/:articleId",
                element: <EditArticle />,
            },
            {
                path: "manageimages/:articleId",
                element: <ManageImages />,
            }
        ],
    },
    {
        path: "/",
        element: (
            <div className="container">
                <Header />
                <main>
                    <Outlet />
                </main>
                <footer>
                    <p>&copy; 2023 My Articles. All rights reserved.</p>
                </footer>
            </div>
        ),
        children: [
            {
                path: "",
                element:
                    <Container maxWidth="lg">
                        <Posts />
                    </Container>,
            },
            {
                path: "/article/:articleId",
                element: <ArticleDetails />,
            },
            {
                path: "/category/:category",
                element: <CategoryArticles />,
            }
        ],
    },
    {
        path: "/signIn",
        element: (
            <Outlet />
        ),
        children: [
            {
                path: "",
                element: <SignIn />,
            }
        ],
    },
    {
        path: "/signUp",
        element: (
            <Outlet />
        ),
        children: [
            {
                path: "",
                element: <SignUp />,
            }
        ],
    }
]);